import "core-js/modules/web.dom.iterable";
export default function (_ref) {
  let {
    req,
    $axios
  } = _ref;
  const {
    header = {}
  } = req || {};
  const xMdM = Object.entries(header).filter((_ref2) => {
    let [key] = _ref2;
    return /^x-mdm-/i.test(key);
  });
  $axios.setHeader('correlation-id', header['correlation-id']);
  $axios.setHeader('mdm-client-ip', header['mdm-client-ip']);
  xMdM.forEach((_ref3) => {
    let [key, value] = _ref3;
    return $axios.setHeader(key, value);
  });
}